/**
 * Classe base para todos os fields.
 * @author: Fabio Junior
 * Date: 19/06/14
 * Time: 16:47
 */



Greenmile.Tag = Greenmile.Tag || {};

Greenmile.Tag.ValidationTag = function () {

    this.validateSmartTag = function (allowSubmit, idTadEdit) {

        this.checktagAndUntagWhen(allowSubmit);
        this.checkAlsoUntagSameTag(allowSubmit, idTadEdit);

    };

    this.checkAlsoUntagSameTag = function (allowSubmit, idActualTag) {
        var tagsOnAlsoUntag = App.Forms.Tag.form.fields.untagAlso.getValue();

        if (tagsOnAlsoUntag && tagsOnAlsoUntag.length > 0) {
            for (var i = 0, size = tagsOnAlsoUntag.length; i < size; i++) {
                if (tagsOnAlsoUntag[i].id === parseInt(idActualTag, 10)) {
                    App.Forms.Tag.form.fields.untagAlso.rootEl.className += ' control-group error';

                    allowSubmit.errorMessages.push(this.getErrorWithMessage("error.SameAlsoUntag"));
                    allowSubmit.status = false;
                    return;
                }
            }
        }

    };

    this.checktagAndUntagWhen = function (allowSubmit) {

        App.Forms.Tag.form.fields.tagWhen.rootEl.className = 'MonetUIFieldPicker';

        if (!App.Forms.Tag.form.fields.tagWhen.getValue() && App.Forms.Tag.form.fields.unTagWhen.getValue()) {
            allowSubmit.errorMessages.push(this.getErrorWithMessage("error.invalidTagWhen"));
            allowSubmit.status = false;
            App.Forms.Tag.form.fields.tagWhen.rootEl.className += ' control-group error';
        }

    };

    this.getErrorWithMessage = function (message) {
        return Monet.Form.Messages.mountErrorMessageObject(message);
    };

};